import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import { retrieveContentfulImage } from '../../common/image.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    image: {
      maxWidth: "100%",
      borderRadius: theme.spacing(2)
    },
    imageDescription: _defineProperty({
      color: theme.palette.grey["800"],
      marginTop: theme.spacing(1)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(0.5)
    })
  };
});
var ImageBlock = function ImageBlock(_ref) {
  var bgColor = _ref.bgColor,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    imageDescription = _ref.imageDescription;
  var classes = useStyles();
  var _window = window,
    width = _window.innerWidth;
  var _useBreakpoints = useBreakpoints(),
    isSmallScreen = _useBreakpoints.isSmallScreen,
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var getDesktopImgWidth = function getDesktopImgWidth(width) {
    if (width > 1280) {
      return 616;
    }
    return (width - 48) / 2;
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }, imageUrl && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, isSmallScreen() || isExtraSmallScreen() ? {
      width: width - 48
    } : {
      width: getDesktopImgWidth(width)
    }),
    className: classes.image,
    alt: imageTitle || ""
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    className: classes.imageDescription,
    align: "center"
  }, imageDescription)));
};
ImageBlock.propTypes = {
  bgColor: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  imageDescription: PropTypes__default.string
};

export { ImageBlock as default };
//# sourceMappingURL=ImageBlock.js.map
